import React from "react"
import {findDOMNode} from "react-dom"
import Popover from "../../../../../../gd-components/gd-popover/popover";
// @ts-ignore
import DatepickerContent from "../../../../../../gd-components/datetime/datepicker/datepicker-content";
import FieldDatetime from "../../date-time";
import FieldsFactory from "../../../../../fields-factory";
import {FieldType} from "../../../../../field-type";
import FieldFormElementView from "../../../../../render/form-elemnent-view";
import Button, {ButtonType} from "../../../../../../gd-components/buttons/gd-button/gd-button-ui5-new";

const debug = false
// const debug = "FieldDatetime_Popover"

type Props = {
    parent      : any
    field       : FieldDatetime
    value       : any
    model       : any
    onSelect    : callback
}

export default class FieldDatetime_Popover extends React.Component<Props, any>{

    public parentPopoverRef = React.createRef<any>();
    public refInput         = React.createRef<any>();
    public refOptionsSelector= React.createRef<any>();
    public refScroll         = React.createRef<any>();

    onSelect = (date:any) => {
        this.props.parent.hidePopover();
        this.props.parent.onValueChange(date)
    }

    onOptionHighlighted = (option:any) => {
        debug && console.log(debug, 'onOptionHighlighted', option)
        // update input according to highlighted option
        this.refInput.current.setInput(option)
    }

    onOptionClick = (option:any) => {
        debug && console.log(debug, 'onOptionClick', option)
        this.props.parent.onOptionClick(option)
    }

    onPopoverKeyDown = (e:any) => {
        debug && console.log(debug, 'onPopoverKeyDown')
        if(this.refOptionsSelector.current) this.refOptionsSelector.current.onPopoverKeyDown(e)
    }

    onInputChange = (value:any) => {
        debug && console.log(debug, 'onInputChange')
        this.props.parent.setValue(value)
    }

    updateScroll = (node:any, isCentered = false) => {
        debug && console.log(debug, "updateScroll", node, isCentered, this.refScroll.current)

        if (!node || !this.refScroll.current) return

        const scrollNode:any = findDOMNode(this.refScroll.current.childrenContainer)

        const nodeTop       = node.offsetTop
        const nodeBottom    = node.offsetTop + node.offsetHeight
        const scrollTop     = scrollNode.scrollTop
        const scrollBottom  = scrollNode.scrollTop + scrollNode.offsetHeight

        debug && console.log(debug, "updateScroll", scrollBottom < nodeBottom, scrollTop > nodeTop)

        // ensure node to be in visible area of scroll
        if (isCentered)                     this.refScroll.current.setScrollTop((nodeTop + nodeBottom) / 2, true, 0)
        else if (scrollBottom < nodeBottom) this.refScroll.current.setScrollTop(nodeBottom - scrollNode.offsetHeight, false, 100)
        else if (scrollTop > nodeTop)       this.refScroll.current.setScrollTop(nodeTop, false, 100)
    }

    onSetTime = (value: Moment | null)=>{
        this.props.parent.onSelectTime(value)
    }

    onAddTime = ()=>{
        this.props.parent.onSelectTime(moment())
    }

    render(){

        const timeOfDayField = FieldsFactory.get({
            fieldId             : 'time',
            type                : FieldType.TIME_OF_DAY,
            label               : 'Time of Day',
            options             : this.props.field.options,
            noValueOption       : false,
            showMenuMore        : false
        })

        return (
            <Popover ref                     = {this.parentPopoverRef}
                     attachment              = "top center"
                     targetAttachment        = "bottom center"
                     getTargetFunc           = {()=>findDOMNode(this.props.parent)}
                     outsideClickIgnoreClass = "gd-popover-search"
                     onClickOutside          = {()=>{this.props.parent.hidePopover()}}
            >
                <DatepickerContent value        = {this.props.value?.date}
                                   onSelect     = {this.onSelect}
                                   minDate      = {this.props.field.minDate}
                                   maxDate      = {this.props.field.maxDate}/>

                {!this.props.value?.time && (
                    <div className="flex-row-center-center  p-b-20 p-l-30 p-r-30">
                        <Button type={ButtonType.SECONDARY_DASHED}
                                icon="i5-my-time"
                                className="w-100-percent"
                                label="Add time"
                                onClick={this.onAddTime}/>
                    </div>
                )}

                {this.props.value?.time && (
                    <div className="flex-row-center-center h-36 p-b-20">
                        <div className="ui5-txt-not-important m-r-10">Time</div>
                        <FieldFormElementView field     = {timeOfDayField}
                                              model     = {this.props.value}
                                              className = "w-150"
                                              onChange  = {this.onSetTime}/>
                    </div>
                )}
            </Popover>
        )
    }
}
